import { parsePhoneNumber } from 'awesome-phonenumber';

/**
 * Format a phone number with an optional extension.
 * @param phoneNum - The phone number to format
 * @param extension - Optional phone extension
 * @returns Formatted phone number, with extension if provided (e.g., "(555) 123-4567 ext. 123")
 */
export const phoneNumberFormat = (phoneNum: string, extension?: string): string => {
  // Future possibility: consider interational phone numbers
  const pn = parsePhoneNumber(phoneNum, 'US');
  const formattedPhone = pn.getNumber('national');
  if (extension) {
    return `${formattedPhone} ext. ${extension}`;
  }
  return formattedPhone;
};

/**
 * @description Utility for extracting only the digits from a phone number.
 * Likely should never be used in our frontend.
 */
export const parsePhoneNumberDigits = (phoneNum: string): string => {
  const pn = parsePhoneNumber(phoneNum, 'US');
  return pn.getNumber('significant');
};

const PHONE_ALLOWED_CHARS_REGEX = /^[0-9()\-+\s.]*$/;
export const isValidPhone = (phone: string): boolean => {
  const REGEX = new RegExp(PHONE_ALLOWED_CHARS_REGEX);
  const validChars = REGEX.test(phone);
  if (!validChars) return false;

  const trimmed = phone.replace(/[(|)|\-|+|\s+|.]/g, '');
  return trimmed.length === 10 || trimmed.length === 11;
};
